<template>
  <div id="page-wrapper">
    <!-- <HeaderNav></HeaderNav> -->
    <div class="imageBox">
      <div class="p1 animate__animated animate__zoomIn">联系我们</div>
      <!-- <div class="p2 animate__animated animate__zoomIn">
        如果有任何问题可以联系我们
      </div> -->
    </div>
    <div class="new_main_box">
      <div class="new_top_box">
        <div class="new_top_flex">
          <div class="p1">联系方式</div>
          <div class="p2">协会邮箱：szshgxh@126.com</div>
          <div class="p2">联系方式：0512-65523286</div>
          <div class="p2">协会地址：苏州市姑苏区阊胥路575号远东大厦703室</div>
          <div class="shareBox">
            <div class="shareBoxFlex">
              <img
                class="image imagetran"
                src="https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/74e9dd714e3046c8b971088a40eec00c.jpg"
                alt="护工协会公众号"
              />
              <p class="p3">护工协会公众号</p>
            </div>
            <div class="shareBoxFlex">
              <img
                class="image imagetran"
                src="https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/6f3c21af59ea47aabdcca16720fe3a07.png"
                alt="协会客服微信号"
              />
              <p class="p3">协会客服微信号</p>
            </div>
            <div class="shareBoxFlex">
              <img
                class="image imagetran"
                src="https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/f992e725ebed453cace2d9f31eb514e8.jpg"
                alt="护工协会小程序"
              />
              <p class="p3">护工协会小程序</p>
            </div>
          </div>
        </div>
        <div class="new_top_flex1">
          <img
            class="image imagetran"
            src="https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/e842a4a7c16648b0a5f077ad3ea2d8e8.png"
            alt=""
          />
        </div>
      </div>
      <div
        id="tianditu-container"
        style="width: 100%; height: 500px; margin-top: 50px"
      ></div>
    </div>
    <Footer></Footer>

    <router-view></router-view>
  </div>
</template>
      
  <script>
import "../assets/css/main.css";
import "../assets/css/noscript.css";
import Footer from "./Footer.vue";
import HeaderNav from "../components/HeaderNav.vue";

export default {
  components: {
    // 注册组件
    Footer,
    HeaderNav,
  },
  name: "About",
  data() {
    return {
      map: null,
      center: [120.599777, 31.3107186], // 地图中心点坐标 - 苏州市姑苏区阊胥路575号远东大厦
      zoom: 17, // 地图缩放级别,
    };
  },
  created() {},
  mounted() {
    // 初始化地图
    this.loadTianMapAPI().then(() => {
      this.initMap();
    });

    // 添加 IntersectionObserver 逻辑
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          !entry.target.classList.contains("animation-triggered")
        ) {
          entry.target.classList.add("fade-in", "animation-triggered");
        }
      });
    });

    const animatedElements = document.querySelectorAll(
      ".bannerBox2, .bannerBox2, .new_top_box, .bottomBox,.bottom_flex,.new_main_box"
    );
    animatedElements.forEach((element) => {
      observer.observe(element);
    });
  },
  beforeDestroy() {
    // 组件销毁时清理天地图
    this.destroyMap();
  },
  destroyed() {
    // 确保在组件完全销毁后移除天地图API
    this.removeTianMapAPI();
  },
  methods: {
    // 动态加载天地图API
    loadTianMapAPI() {
      return new Promise((resolve, reject) => {
        // 检查是否已经加载过天地图API
        if (window.T) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = 'tianditu-script'; // 添加ID方便后续移除
        script.src = 'https://api.tianditu.gov.cn/api?v=4.0&tk=2ce6f30d42343ba8058065080bb44ae8';
        script.onload = () => {
          console.log('天地图API加载成功');
          resolve();
        };
        script.onerror = () => {
          console.error('天地图API加载失败');
          reject(new Error('天地图API加载失败'));
        };
        document.head.appendChild(script);
      });
    },
    initMap() {
      // 初始化天地图
      this.map = new T.Map("tianditu-container");
      
      // 设置地图中心点和缩放级别
      const centerPoint = new T.LngLat(this.center[0], this.center[1]);
      this.map.centerAndZoom(centerPoint, this.zoom);

      // 添加标记点
      const marker = new T.Marker(centerPoint);
      this.map.addOverLay(marker);

      // 创建信息窗口
      const infoWindow = new T.InfoWindow();
      infoWindow.setContent(`
        <div style="padding: 10px;">
          <h4 style="margin: 0 0 10px 0; color: #0ba29a;">苏州市护工协会</h4>
          <p style="margin: 5px 0;">地址：苏州市姑苏区阊胥路575号远东大厦703室</p>
          <p style="margin: 5px 0;">电话：0512-65523286</p>
          <p style="margin: 5px 0;">邮箱：szshgxh@126.com</p>
        </div>
      `);

      // 点击标记显示信息窗口
      marker.addEventListener("click", () => {
        marker.openInfoWindow(infoWindow);
      });

      // 默认打开信息窗口
      marker.openInfoWindow(infoWindow);

      // 添加缩放控件
      const zoomControl = new T.Control.Zoom();
      this.map.addControl(zoomControl);

      // 添加比例尺控件
      const scaleControl = new T.Control.Scale();
      this.map.addControl(scaleControl);
    },
    // 销毁地图实例
    destroyMap() {
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }
    },
    // 移除天地图API脚本和相关样式
    removeTianMapAPI() {
      // 移除天地图脚本
      const script = document.getElementById('tianditu-script');
      if (script) {
        script.remove();
      }

      // 移除天地图注入的全局样式
      const styles = document.querySelectorAll('style, link[rel="stylesheet"]');
      styles.forEach(style => {
        // 检查是否是天地图相关的样式
        if (style.textContent && style.textContent.indexOf('tianditu') !== -1) {
          style.remove();
        }
        if (style.href && style.href.indexOf('tianditu') !== -1) {
          style.remove();
        }
      });

      // 清理全局 T 对象
      if (window.T) {
        delete window.T;
      }

      console.log('天地图API已清理');
    },
  },
};
</script>

<style scoped>
html {
  font-size: 20px;
}

/* 动画样式 */
.fade-in {
  opacity: 1;
  transition: opacity 1s ease-in-out;
  transform: translateY(0);
  animation: fadeInUp 1s ease-in-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.imageBox {
  background-image: url("https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/25a0afb050de48ba81b651fd5883e7d0.png");
  background-size: cover;
  background-position: center;
  color: #fff;
  padding: 12em 18em 12em 18em;
  cursor: default;
  height: 560px;
  text-align: left;
}

.imageBox .p1 {
  font-family: OPPOSans;
  font-weight: 400;
  font-size: 3.2em;
  color: #ffffff;
  margin-bottom: 50px;
}

.imageBox .p2 {
  font-family: OPPOSans;
  font-weight: 400;
  font-size: 1.4em;
  color: #ffffff;
}

.new_main_box {
  padding: 3em 18em;
}

.new_top_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.new_top_flex {
  width: 27em;
  height: 25em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.new_top_flex1 {
  width: 27em;
  height: 25em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.new_top_flex1 .image {
  max-width: 100%;
  height: 25em;
}

.new_top_flex .shareBox {
  display: flex;
  justify-content: space-between;
}

.new_top_flex .shareBox .shareBoxFlex .image {
  width: 6.8em;
  height: 6.8em;
}

.new_top_flex .shareBox .shareBoxFlex .p3{
  font-weight: 600;
}

.new_top_flex .p1 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 2em;
  color: #0ba29a;
}

.new_top_flex .p2 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 1.4em;
  color: #434343;
}

@media screen and (max-width: 1680px) {
  .imageBox{
    padding: 12em 10em 12em 10em;
  }
  .new_main_box{
    padding: 3em 10em;
  }
}

@media screen and (max-width: 1280px) {
  .imageBox{
    padding: 12em 10em 12em 10em;
  }
  .new_main_box{
    padding: 3em 10em;
  }
}

@media screen and (max-width: 840px) {
  html {
    font-size: 10px;
  }

  .imageBox {
    background-image: url("https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/3a2ee18a8d9e48cdb393532b291cdd3c.png");
    background-size: 100% 100%;
    color: #fff;
    padding: 12em 60px 12em 60px;
    cursor: default;
    height: 560px;
    text-align: center;
    line-height: 40px;
  }

  .new_top_box {
    flex-direction: column;
  }

  .new_top_flex:nth-child(1) {
    width: 100%;
    order: 2;
  }

  .new_top_flex:nth-child(2) {
    width: 100%;
    order: 1;
    margin-bottom: 20px;
  }

  .new_main_box {
    padding: 60px;
  }

  .new_top_flex .p1 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 1.5em;
    color: #0ba29a;
  }

  .new_top_flex .p2 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 1em;
    color: #434343;
  }

  .new_top_flex .shareBox {
    display: inline-block;
  }

  .new_top_flex .shareBox .image {
    width: 15em;
    height: 15em;
    text-align: center;
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  .new_top_flex1 {
    margin-bottom: 2em;
  }
}

@media screen and (max-width: 736px) {
  html {
    font-size: 10px;
  }

  .imageBox {
    background-image: url("https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/3a2ee18a8d9e48cdb393532b291cdd3c.png");
    background-size: 100% 100%;
    color: #fff;
    padding: 12em 60px 12em 60px;
    cursor: default;
    height: 560px;
    text-align: center;
    line-height: 40px;
  }

  .new_top_box {
    flex-direction: column;
  }

  .new_top_flex:nth-child(1) {
    width: 100%;
    order: 2;
  }

  .new_top_flex:nth-child(2) {
    width: 100%;
    order: 1;
    margin-bottom: 20px;
  }

  .new_main_box {
    padding: 60px;
  }

  .new_top_flex .p1 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 1.5em;
    color: #0ba29a;
  }

  .new_top_flex .p2 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 1em;
    color: #434343;
  }

  .new_top_flex .shareBox {
    display: flex;
  }

  .new_top_flex .shareBox .image {
    width: 15em;
    height: 15em;
    text-align: center;
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
  }

  .new_top_flex1 {
    margin-bottom: 2em;
  }
}
</style>